import { render } from "./UsersList.vue?vue&type=template&id=bf88dfb0"
import script from "./UsersList.vue?vue&type=script&lang=js"
export * from "./UsersList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__